<div class="integration-setup-logo" [ngClass]="'source-' + source">
  <img *ngIf="imageSourceBySource[source]" [src]="imageSourceBySource[source]" [alt]="source">
</div>
